import React from "react";
import { Link } from "react-router-dom";

const EmptyCoupons = () => {

    return (

        <div className="empty-coupons">

            <h1>🎁</h1>

            <h2>No Coupons Found</h2>

            <p>Create your first coupon.</p>

            <Link
                to="/admin/coupons/create"
                className="btn btn-primary"
            >
                Create Coupon
            </Link>

        </div>

    );
};

export default EmptyCoupons;